import React, { ButtonHTMLAttributes, HTMLAttributes } from 'react'
import { ReactNode } from 'react'

export function Button(props: HTMLAttributes<HTMLButtonElement>) {
    return (
        <button {...props} className="py-2 px-4 border rounded w-full"></button>
    )
}
